<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-04 15:35:59
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-04 16:54:35
 * @FilePath: /chaoyongtuan/src/views/settings/tagManage/components/del.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog :visible.sync="visible" title="删除提示" width="426px" :close-on-click-modal="false">
		<div class="flex-row">
			<img src="@/assets/public/warning-org.png" style="width: 16px; height: 16px; margin-top: 4px" alt="" />
			<div class="font-h4-medium yx-color-text-primary ml-6">
				<p>标签删除后，内容上的该标签会被移除。删除后的标签将无法恢复!</p>
			</div>
		</div>
		<div class="footer-dialog" slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="del">删 除</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { batchDelTag } from '@/api/tagManagement';
export default {
	data() {
		return {
			visible: false,
			id: '',
		};
	},
	methods: {
		show(id) {
			this.id = id;
			this.visible = true;
		},
		async del() {
			const { id } = this;
			await batchDelTag({ ids:[id] });
			this.$message.success('操作成功');
			this.$emit('refreshList');
			this.handleClose();
		},
		handleClose() {
			this.visible = false;
		},
	},
};
</script>
